import { Controller } from '@hotwired/stimulus';

export default class RequiredConfirmedButtonController extends Controller {
  static targets = [
    'confirmed',
    'button'
  ];

  toggleButton() {
    this.buttonTarget.disabled = !this.confirmedTarget.checked;
  }
}
